/**
 * 接口文件
 */

import request from './request';
import store from '@/store';

export default {
    /**
    * 申请成为代理商
    */
    applyAgent: model => request.post('/agent/applyAgent', model),
    /**
    * 获取代理商信息
    */
    getAgentInfo: model => request.post('/agent/getAgentInfo', model),
    /**
    * 获取代理商ID
    */
    getAgentId: () => request.get('/agent/getAgentId'),
    /**
    * 获取代理商出入账金额
    */
    getIncome: () => request.post('/agent/getIncome', { 'agentId': store.state.user.agentId }),
    /**
    * 获取代理商粉丝列表(分页)
    */
    getAgentFansList: model => request.post('/agent/getAgentFansList', { ...model, 'id': store.state.user.agentId }),
    /**
    * 获取代理商添加商品列表（分页）
    */
    getAgentGoodsList: model => request.post('/agent/commodity/agent/list', { ...model, 'agentId': store.state.user.agentId }),
    /**
   * 获取店铺列表
   */
    getShopList: () => request.get('/agent/list'),
    /**
    * 获取佣金明细（分页）
    */
    getCommissionList: model => request.post('/agent/getCommissionList', { ...model, 'agentId': store.state.user.agentId }),
    /**
    * 添加代理商商品
    */
    commodityBindAgent: model => request.post('/agent/commodityBindAgent', { ...model, 'id': store.state.user.agentId }),
    /**
   * 获取代理商品列表（分页）
   */
    getCommodityList: model => request.post('/agent/getCommodityList', model),
    /**
    * 移除代理商品
    */
    commodityUnbindAgent: model => request.post('/agent/commodityUnbindAgent', { ...model, 'id': store.state.user.agentId }),
    /**
    * 关注 代理商
    */
    focusAgent: model => request.post('/agent/focusAgent', { ...model }),
    /**
    * 取消关注 代理商
    */
    cancelFocusAgent: model => request.post('/agent/cancelFocusAgent', { ...model }),
    /**
    * 重新认证成为代理商
    */
    updateAgent: model => request.post('/agent/updateAgent', { ...model, 'id': store.state.user.agentId }),
    /**
    * 申请提现
    */
    withdraw: model => request.post('/agent/withdraw', { ...model, 'agentId': store.state.user.agentId }),
    /**
    * 申请提现历史记录（分页）
    */
    getWithdrawList: model => request.post('/agent/getWithdrawList', { ...model, 'agentId': store.state.user.agentId }),
    /**
    * 取消关注
    */
    userFocusAgentList: model => request.post('/agent/userFocusAgentList', { ...model, 'id': store.state.user.agentId }),
}